module.exports = __webpack_public_path__ + "assets/img/large_logo_white_only.2e0ff265.svg";